import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './RequestedProvider.sass'
import Avatar, { Badge } from 'components/Avatar'
import Member from 'iam/models/Member'
import Tooltip from 'components/Tooltip'
import { truncate } from 'lodash'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
  DropdownTitle,
} from 'components/Dropdown'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import JobViewModel from '../../JobViewModel'

interface Props {
  vm: JobViewModel
  provider: Member
}

export default observer(function CollaboratorItem({ provider, vm }: Props) {
  return (
    <div
      className={cx(
        styles.root,
        provider.email && styles.withEmail,
        provider.phone && styles.withPhone,
      )}
    >
      <div className={styles.info}>
        <div className={styles.header}>
          <p className={styles.title}>{provider.displayName}</p>

          {vm.canViewRequestedProviderActionsMenu && (
            <Dropdown
              autoDismiss
              dataTest="collaborators-card-requested-provider-dropdown-menu"
              button={
                <IconButton>
                  <Icon name="more" rotate={90} />
                </IconButton>
              }
            >
              <DropdownTitle>Actions</DropdownTitle>

              <DropdownItem
                icon={<Icon name="delete" />}
                onClick={() => vm.removeRequestedChampionProviderAsAdmin()}
                data-test="collaborators-remove-requested-pro-dropdown-item"
              >
                <DropdownItemTitle>Remove provider</DropdownItemTitle>
              </DropdownItem>
            </Dropdown>
          )}
        </div>

        <div className={styles.subtitle}>
          <div className={styles.subtitleInfo}>
            {provider.email && (
              <>
                {provider.email.length >= 38 ? (
                  <Tooltip content={provider.email}>
                    <p className={styles.email}>
                      {truncate(provider.email, { length: 38 })}
                    </p>
                  </Tooltip>
                ) : (
                  <p className={styles.email}>{provider.email}</p>
                )}
              </>
            )}
            {provider.phone && <p className={styles.phone}>{provider.phone}</p>}
          </div>
        </div>
        <div className={styles.footer}>
          <p>
            <span className={styles.pro}>Requested Provider</span>
          </p>

          <div className={styles.avatarContainer}>
            <Avatar
              badge={provider.user.online ? Badge.Online : Badge.Offline}
              size={32}
              subject={provider}
            />
          </div>
        </div>
      </div>
    </div>
  )
})
